import { styled } from '@mui/material';

export const GradientBackground = styled('div')<{ inverse?: boolean }>(({ theme, inverse }) => ({
  background: `linear-gradient(to bottom, ${theme.palette.primaryDark[inverse ? 700 : 800]} 0%, ${
    theme.palette.primaryDark[inverse ? 800 : 700]
  } 100%)`,
  zIndex: -10,
}));
